"use client";

// @ts-ignore
import version from './version';
export default version;